import React from 'react';
import config from '../config';
import Box from "./Box";

type LogoProps = {
    noText?: boolean,
    color?: string,
    variant?: string,
    text?: string,
}

export function Logo

({noText, color, variant, text}: LogoProps) {

    const imageSize = variant === "large" ? '80px' : '48px';
    return (
            <Box sx={{
                fontSize: "22px",
                justifyContent: "center",
                alignItems: "center"
            }}>
                <Box sx={{
                    fontSize: "22px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}>
                    <img
                            style={{
                                marginRight: "5px",
                                zIndex: 0,
                            }}
                            // src={dark ? '/images/icon48.png' : '/images/icon48_light.png'}
                            src={'/images/icon512_light3.png'}
                            width={imageSize}
                            height={imageSize}
                            alt={"logo"}
                    />
                    {!noText && <Box

                            color={color}
                            sx={{
                                fontFamily: "'Lexend Deca', sans-serif",
                                whiteSpace: "nowrap",
                                fontSize: variant === "large" ? "65px" : "30px"
                            }}
                    >{text || config.appName}</Box>}
                </Box>
            </Box>
    );
}
